var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 268.07 238.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ee404c;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134,238.47q-55.75,0-111.52,0A22.1,22.1,0,0,1,.74,221.73c-1.69-6.57-.42-12.72,3-18.64q29.1-50.13,58-100.38,26.08-45.18,52.19-90.34c8.15-14,25.66-16.57,36.36-5.31a30.94,30.94,0,0,1,4.13,5.75q55,95.19,109.91,190.41c9.83,17.05-.68,35.23-20.32,35.25q-55,.06-110,0Zm15-123.46h-.19c0-10.72.2-21.45-.08-32.16a11.8,11.8,0,0,0-9.32-11.74c-6.07-1.55-12.19-1.34-16.87,4-2.83,3.23-3.33,7.13-3.33,11.19q0,28.42,0,56.86a27.4,27.4,0,0,0,.45,5.2,12.43,12.43,0,0,0,9.29,10.21c11.43,3.26,19.93-3.21,20-15.12C149,134,148.94,124.49,148.94,115ZM134.22,208.2a14.62,14.62,0,0,0,14.57-14.86,14.76,14.76,0,1,0-29.51.35A14.64,14.64,0,0,0,134.22,208.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.94,115c0,9.48.06,19,0,28.43-.09,11.91-8.59,18.38-20,15.12a12.43,12.43,0,0,1-9.29-10.21,27.4,27.4,0,0,1-.45-5.2q0-28.43,0-56.86c0-4.06.5-8,3.33-11.19,4.68-5.33,10.8-5.54,16.87-4a11.8,11.8,0,0,1,9.32,11.74c.28,10.71.08,21.44.08,32.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.22,208.2a14.64,14.64,0,0,1-14.94-14.51,14.76,14.76,0,1,1,29.51-.35A14.62,14.62,0,0,1,134.22,208.2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warningRed.b33c01cdeefc9d2044e30a80a7c339ca.svg";
export { ForwardRef as ReactComponent };